import React from 'react';
import { Mail, MessageCircle } from 'lucide-react';

export default function ContactSection({ t, portfolio, currentLang, getText }) {
    const phoneNumber = portfolio.personal.phone ? portfolio.personal.phone.replace(/\D/g, '') : '';

    const whatsappUrl = phoneNumber ? `https://wa.me/${phoneNumber}` : '#';

    // Extract vanilla slug from LinkedIn URL (e.g. "https://www.linkedin.com/in/foo-bar/" -> "foo-bar")
    const getLinkedInVanity = (url) => {
        if (!url) return null;
        const matches = url.match(/linkedin\.com\/in\/([^/]+)/);
        return matches ? matches[1] : null;
    };
    const linkedInVanity = getLinkedInVanity(portfolio.personal.linkedin);

    React.useEffect(() => {
        if (linkedInVanity) {
            const script = document.createElement('script');
            script.src = "https://platform.linkedin.com/badges/js/profile.js";
            script.async = true;
            script.defer = true;
            script.type = "text/javascript";
            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        }
    }, [linkedInVanity]);

    return (
        <section id={t.nav[4].toLowerCase().replace(/\s+/g, '-')} className="py-24 px-4 bg-slate-900 border-t border-slate-800">
            <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-4xl md:text-5xl font-black mb-8 bg-gradient-to-r from-cyan-400 to-blue-600 bg-clip-text text-transparent">
                    {t.contact}
                </h2>
                <p className="text-xl text-slate-400 mb-12 leading-relaxed">
                    {t.contactDesc}
                </p>

                <div className="flex flex-wrap justify-center gap-6">
                    <a
                        href={`mailto:${portfolio.personal.email}`}
                        className="group bg-slate-800 hover:bg-cyan-500/20 border border-slate-700 hover:border-cyan-500 px-8 py-4 rounded-xl transition-all duration-300 flex items-center gap-3 hover:-translate-y-1"
                    >
                        <Mail className="text-slate-300 group-hover:text-cyan-400 transition-colors" size={24} />
                        <span className="font-semibold text-slate-200 group-hover:text-cyan-400">{t.sendEmail}</span>
                    </a>

                    {portfolio.personal.phone && (
                        <>
                            <a
                                href={whatsappUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group bg-green-600/10 hover:bg-green-600/20 border border-green-600/50 hover:border-green-500 px-8 py-4 rounded-xl transition-all duration-300 flex items-center gap-3 hover:-translate-y-1"
                            >
                                <MessageCircle className="text-green-500 group-hover:text-green-400 transition-colors" size={24} />
                                <span className="font-semibold text-green-500 group-hover:text-green-400">WhatsApp</span>
                            </a>


                        </>
                    )}
                </div>

                {linkedInVanity && (
                    <div className="mt-12 flex justify-center grayscale hover:grayscale-0 transition-all duration-500">
                        <div
                            className="badge-base LI-profile-badge"
                            data-locale="es_ES"
                            data-size="large"
                            data-theme="dark"
                            data-type="HORIZONTAL"
                            data-vanity={linkedInVanity}
                            data-version="v1"
                        >
                            <a
                                className="badge-base__link LI-simple-link"
                                href={portfolio.personal.linkedin + "?trk=profile-badge"}
                            >

                            </a>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
